import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { PRODUCTS } from "@/data/site";

export default function Products() {
  return (
    <div data-testid="products-page">
      <section className="container-page pt-20 md:pt-28 pb-12">
        <Reveal>
          <div className="overline text-[#D97706]">Products</div>
          <h1 className="font-display font-light text-5xl sm:text-6xl tracking-tight mt-4 max-w-4xl">
            Tier-1 hardware, matched to your site and load.
          </h1>
          <p className="mt-6 text-[#57534E] text-lg max-w-2xl">
            We do not push a single brand. We specify the right module, inverter and battery for the application — from a single home up to multi-megawatt commercial sites.
          </p>
        </Reveal>
      </section>

      <section className="container-page pb-24 space-y-10">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.05}>
            <div
              className={`grid md:grid-cols-12 gap-8 items-center bg-[#F5F5F0] border border-[#E7E5E4] rounded-3xl overflow-hidden`}
              data-testid={`product-card-${p.id}`}
            >
              <div className={`md:col-span-6 aspect-[4/3] md:aspect-auto md:h-full ${i % 2 === 1 ? "md:order-2" : ""}`}>
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="md:col-span-6 p-8 md:p-12">
                <div className="overline text-[#D97706]">0{i + 1}</div>
                <h2 className="font-display text-3xl sm:text-4xl font-medium tracking-tight mt-3">{p.title}</h2>
                <p className="mt-4 text-[#57534E]">{p.desc}</p>
                <ul className="mt-6 space-y-2">
                  {p.points.map((pt) => (
                    <li key={pt} className="flex items-center gap-2 text-sm text-[#1C1917]">
                      <Check className="w-4 h-4 text-[#166534]" /> {pt}
                    </li>
                  ))}
                </ul>
                {p.brands && (
                  <div className="mt-6" data-testid={`product-brands-${p.id}`}>
                    <div className="overline text-[#D97706] mb-3">Brands we install</div>
                    <div className="grid sm:grid-cols-2 gap-3">
                      {p.brands.map((b) => (
                        <div key={b.name} className="bg-[#FDFBF7] border border-[#E7E5E4] rounded-xl p-3">
                          <div className="font-display text-sm font-semibold">{b.name}</div>
                          <div className="text-xs text-[#57534E] mt-0.5">{b.spec}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <Link
                  to="/contact"
                  data-testid={`product-quote-${p.id}`}
                  className="inline-flex items-center gap-2 mt-8 rounded-full bg-[#1C1917] text-[#FDFBF7] hover:bg-[#D97706] px-6 py-3 text-sm font-medium transition-colors"
                >
                  Get a quote <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
